import { render } from "./VentasFormulario.vue?vue&type=template&id=5f8435e3&scoped=true"
import script from "./VentasFormulario.vue?vue&type=script&lang=js"
export * from "./VentasFormulario.vue?vue&type=script&lang=js"

import "./VentasFormulario.vue?vue&type=style&index=0&id=5f8435e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8435e3"]])

export default __exports__